import { Badge } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { NodeModel } from "@minoru/react-dnd-treeview";
import React from "react";
import { FileProperties } from "../../models/FileProperties";
import { TypeIcon } from "../DelayConfiguration/TypeIcon";
import { multipleDragPreviewStyles } from "../../styles/dragPreviewStyles";

type Props = {
  dragSources: NodeModel<FileProperties>[];
};

export const MultipleDragPreview: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = multipleDragPreviewStyles(theme);

  return (
    <Badge
      slotProps={{
        badge: {
          sx: styles.badge,
        },
      }}
      color="error"
      badgeContent={props.dragSources.length}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <div
        style={styles.root as React.CSSProperties}
        data-testid="custom-drag-preview"
      >
        {props.dragSources.map((node) => (
          <div key={node.id} style={styles.item as React.CSSProperties}>
            <div style={styles.icon as React.CSSProperties}>
              <TypeIcon
                droppable={node.droppable || false}
                fileType={node?.data?.fileType}
              />
            </div>
            <div style={styles.label as React.CSSProperties}>{node.text}</div>
          </div>
        ))}
      </div>
    </Badge>
  );
};
